<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :span="8">
            <a-form-item label="表单名称">
              <j-input placeholder="请输入表单名称" v-model="queryParam.name"></j-input>
            </a-form-item>
          </a-col>

          <a-col :span="8">
            <a-form-item label="英文名称">
              <j-input placeholder="请输入英文名称" v-model="queryParam.nameEn"></j-input>
            </a-form-item>
          </a-col>

            <a-col :span="8">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"

        rowKey="id"
        :columns="columns"
        :dataSource="dateSource2"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="addFormListHandle(record)">确认</a>
        </span>

      </a-table>
    </div>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { CACHE_PROJECT_ID } from '@/constants/project'
  import Vue from 'vue'
  import JInput from '@/components/jeecg/JInput'
  export default {
    name: "CsimVisitUnSelectFormList",
    mixins:[JeecgListMixin],
    components: {
      JInput,
    },
    props:{
      existIdList:{
        type:Array,
        default:()=>{
          return []
        }
      }
    },
    data () {
      return {
        description: '项目受试者自定义配置管理页面',
        // 表头
        columns: [
		   {
            title: '表单名称',
            align:"center",
            dataIndex: 'name'
           },
		   {
            title: '英文名称',
            align:"center",
            dataIndex: 'nameEn'
           },

          {
            title: '表单类型',
            align:"center",
            dataIndex: 'type_dictText'
          },
          {
            title: '表单项数',
            align:"center",
            dataIndex: 'itemCount'
          },
          {
            title: '表单说明',
            align:"center",
            ellipsis: true,
            dataIndex: 'description'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/project/projectForm/list",
          delete:'/project/projectForm/delete'
       },
        disableMixinCreated:true,
        viewVisible:false,
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        current:{},
      }
  },
  computed: {
      dateSource2(){
        return this.dataSource.filter(item=> this.existIdList.indexOf(item.id)===-1)
      }
  },
    mounted(){
      this.baseQueryParam = {projectId:this.projectId,status:'1'}
      this.loadData()

    },
    methods: {
      formItemSetHandle(record){
        this.$refs.formItemSet.view(record)
      },
      onViewClose(){
        this.viewVisible = false
      },
      addFormListHandle(record){
        this.$emit('addFormListHandle',Object.assign({},record))
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>